import * as S from "../../Style/Page/Hat.style.js";
import { Link } from "react-router-dom";
import { ReactComponent as Home } from "../../assets/icon/home.svg";
import Arrow from "../../assets/icon/lnb_arrow.png";
import PageTitle from "../../Component/PageTitle.js";
const Factory1 = `${process.env.REACT_APP_ASSET_BASE || ""}/static/media/20. 인도네시아 공장.affd2e250fead336a480.jpg`;
const Hat1 = `${process.env.REACT_APP_ASSET_BASE || ""}/static/media/21. 인도네시아 공장 의류1.bc3b2480f4f4ed42fe33.png`;
const Hat2 = `${process.env.REACT_APP_ASSET_BASE || ""}/static/media/22. 인도네시아 공장 의류2.662af25c6390adb3739c.png`;
import HatPageTopLine from "../../Component/HatPageTopLine.js";
const ProductionCorporation4 = () => {
  return (
    <S.Page className={localStorage.getItem("language")}>
      <HatPageTopLine name={"모자사업"} ename={"YoungAn Hat"} />
      <section className="section" id="hat-introduce-section">
        <S.PageNavidation>
          <Link to="/" className="logo">
            <Home />
          </Link>
          <S.Nav height={"364px"}>
            <S.NavItem>
              <Link to="/HatBusiness/Introduce">
                <div className="kor">모자사업</div>
                <div className="eng">Hat Business</div>
              </Link>
            </S.NavItem>

            <div className="open-list">
              <S.NavItem className="list-inner-item">
                <Link to="/HatBusiness/Introduce">
                  <div className="kor">모자사업</div>
                  <div className="eng">Hat Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/ForkLiftBusiness/Introduce">
                  <div className="kor">지게차사업</div>
                  <div className="eng">Fork Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/CarBusiness/introduce">
                  <div className="kor">자동차사업</div>
                  <div className="eng">Car Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/BusBusiness/OverseasBus">
                  <div className="kor">버스사업</div>
                  <div className="eng">Bus Business</div>
                </Link>
              </S.NavItem>

              <S.NavItem className="list-inner-item">
                <Link to="/GeneralBusiness/introduce">
                  <div className="kor">일반사업</div>
                  <div className="eng">General Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/SocialBusiness/SocialService">
                  <div className="kor">사회사업</div>
                  <div className="eng">Social Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/WBH/WBH">WBH</Link>
              </S.NavItem>
            </div>
            <img src={Arrow} className="down-arrow" alt="" />
          </S.Nav>

          <S.Nav height={"260px"}>
            <S.NavItem>
              <Link to="/HatBusiness/ProductionCorporation">
                <div className="kor">직경영사업장</div>
                <div className="eng">Direct Management Affiliates</div>
              </Link>
            </S.NavItem>
            <div className="open-list">
              <S.NavItem className="list-inner-item">
                <Link to="/HatBusiness/Introduce">
                  <div className="kor">모자사업</div>
                  <div className="eng">Hat Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/HatBusiness/KoreaCompany">
                  <div className="kor">영안모자 한국본사</div>
                  <div className="eng">Korean Headquarters</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/HatBusiness/ProductionCorporation">
                  <div className="kor">직경영사업장</div>
                  <div className="eng">Direct Management Affiliates</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/HatBusiness/SalesCorporation">
                  <div className="kor">위탁경영사업장</div>
                  <div className="eng">Indirect Management Affiliates</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/HatBusiness/History">
                  <div className="kor">주요사업이력</div>
                  <div className="eng">Major business history</div>
                </Link>
              </S.NavItem>
            </div>
            <img src={Arrow} className="down-arrow" alt="" />
          </S.Nav>
          <S.Nav height={"208px"}>
            <S.NavItem>
              <Link to="/HatBusiness/ProductionCorporation4">
                <div className="kor">인도네시아법인</div>
                <div className="eng"> Indonesia company</div>
              </Link>
            </S.NavItem>
            <div className="open-list">
              <S.NavItem className="list-inner-item">
                <Link to="/HatBusiness/ProductionCorporation">
                  <div className="kor">스리랑카법인</div>
                  <div className="eng">Sri Lanka company</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/HatBusiness/ProductionCorporation2">
                  <div className="kor">방글라데시법인</div>
                  <div className="eng">Bangladesh company</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/HatBusiness/ProductionCorporation3">
                  <div className="kor">베트남법인</div>
                  <div className="eng">Vietnam company</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/HatBusiness/ProductionCorporation4">
                  <div className="kor">인도네시아법인</div>
                  <div className="eng">Indonesia company</div>
                </Link>
              </S.NavItem>
            </div>
            <img src={Arrow} className="down-arrow" alt="" />
          </S.Nav>
        </S.PageNavidation>

        <div className="wrap">
          <div className="inner">
            <PageTitle titleko={"인도네시아 법인"} titleeng={"Indonesia company"} />
            <div className="page-text">
              <div className="kor">인도네시아 법인 / YoungAn Int'l Lanka(Pvt) Ltd.</div>
              <div className="eng">Indonesia company / PT.NAMNAM Fashion Industries</div>
            </div>

            <S.ImgHolderFullsize>
              <img src={Factory1} className="holder-img" alt="" />
              <div className="holder-name">
                <div className="kor">스리랑카 1공장</div>
                <div className="eng">Indonesia Factory</div>
              </div>
            </S.ImgHolderFullsize>

            <PageTitle titleko={"주요생산제품"} titleeng={"Major Production Products"} />
            <S.ImgHolderFlex className="center">
              <img src={Hat1} alt="" />
              <img src={Hat2} alt="" />
            </S.ImgHolderFlex>
            <PageTitle titleko={"주요이력"} titleeng={"Major History"} />

            <div className="page-text">
              <div className="page-text-flex">
                <div className="page-text-area">
                  <div className="page-text-title">
                    <div className="kor">PT.NAMNAM Fashion Industries 법인개요</div>
                    <div className="eng">Company Profile of PT.NAMNAM Fashion Industries</div>
                  </div>
                  <div className="kor">
                    법인 설립: 1989년
                    <br />
                    영안 인수: 2020년</div>
                  <div className="eng">
                    Establishment : 1989
                    <br />
                    Acquired by YoungAn : 2020
                  </div>

                </div>
              </div>
              <div className="kor">※ 의류 생산공장 / 2024년 모자 병행 생산
                <br />
                ※ 주요 생산 품목 : 남/녀 이너웨어, 기능성 웨어, 여성용 속옷
                <br />
                ※ 생산라인 : 24라인 / 년 생산캐파 : 4,800,000 피스
                <br />
                인도네시아 공장 Jl. Mahar</div>
              <div className="eng">
                ※ Apparel production factory / Plan to start cap production from 2024 <br />
                ※ Major Production Products : Innerwear for Men&Women, Functional wear, Underwear for Women <br />
                ※ Number of Production Line : 24 Lines / Yearly Production Capacity : 4,800,000 pieces <br />
              </div>

            </div>
          </div>
        </div>
      </section>
    </S.Page>
  );
};

export default ProductionCorporation4;
